/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Popover, TextField } from '@material-ui/core';
import React, { useState, useLayoutEffect, useEffect } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ExportIcon from '../../../../../assets/images/Icon-Component-Export.svg';
import CommentIconVisible from '../../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../../assets/images/comment-dots.svg';
import * as ErrorMessages from '../../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { setClaimDetailsId } from '../../../ClaimDetails/store/actions';
import ErrorPopup from '../../../NDC/component/ErrorPopup';
import {
  navigateToProvider,
  setDisabled,
  setEditedRows,
  setSelectedClaim,
  setSelectedClaimRecordIndex,
  setTableData,
  setSinglePageClaimData
} from '../../store/action';
import { getClaimDetails } from '../../../ClaimDetails/store/actions';
import {
  redirectURLLink,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';


import CommentAndCorrespondenceComponent from '../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { formatDateUnix } from '../../../../../SharedModules/utilities/dateUtilities';
import { getReferenceValue, multipleClaimsHead } from './tableHead';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import SelectBoxWithoutBox from '../../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import TableGridWithFeatures from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';

const CustomSelectedClaimAction = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    tableData,
    selectBy,
    disputeResolutionToggle: isChecked,
    rebateType,
    claimReferenceData,
    selectedClaimMode,
  } = useSelector((state) => state.sharedState.claim);
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.claim?.searchScreenReduxObj
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [error, setError] = useState(null);
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [corrId, setCorrId] = useState(null);
  const [showComments, setShowComments] = useState(false);
  const [byRowOrigNumOfUnits, setByRowOrigNumOfUnits] = useState('');
  const [claimValueError, setClaimValueError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [refreshTable, setRefreshTable] = useState(true);
  const [selectList, setSelectList] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [originalUnit, setOriginalUnit] = useState('');
  const [rows, setRows] = useState(tableData);
  const [selectedRowIndex, setSelectedRowIndex] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [claimValue, setClaimValue] = useState('');
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
    const editedDataRedux  = useSelector((state) => {
      return state.sharedState.claim.editedData;
    });

  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  useEffect(() => {
    const rowsData = tableData?.map((item) => ({
      ...item,
      computedCategoryCd: getReferenceValue(
        claimReferenceData?.CLAIM_CATEGORY_CD || [],
        item.claimCategoryCd
      ),
      providerIdTypeVal: item?.providerIdTypeCd
        ? getReferenceValue(
            claimReferenceData?.PROVIDER_ID_TYPE_CD,
            item?.providerIdTypeCd
          )
        : null,
    }));

    let uniqueOriginalUnits = [];
    const uniqueCategory = [];
    const indexes = [];

    rowsData.forEach((item, i) => {
      if (parseFloat(item.origNumOfUnits) >= 0) {
        uniqueOriginalUnits.push(item.origNumOfUnits);
      }
      if (
        uniqueCategory.indexOf(item.computedCategoryCd) === -1 &&
        parseFloat(item.origNumOfUnits) === parseFloat(byRowOrigNumOfUnits)
      ) {
        uniqueCategory.push(item.computedCategoryCd);
      }
      indexes.push(i);
    });
    uniqueOriginalUnits = [...new Set(uniqueOriginalUnits)];
    setCategoryName(uniqueCategory?.join(', '));
    setSelectedRowIndex(indexes);
    setRows(rowsData);
    setSelectedRows(rowsData);
    setSelectList(
      uniqueOriginalUnits?.map((value) => ({
        id: value,
        name: value,
      }))
    );
    handleFilterChange(uniqueOriginalUnits[0]);
  }, [tableData, byRowOrigNumOfUnits]);

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    // Avoid state updates if selectedRows haven't changed
    if (selectedRows.length !== selectedRowIndex.length) {
      setSelectedRowIndex(selectedRows.map(row => row.id));
    }
  };
  const logInUser = useSelector(
      (state) => state?.sharedState?.SharedReducer?.logInUser
    );
   const handleViewDetailsForClaims = (data) => {
     dispatch(
       getClaimDetails({
         claimId: data?.claimId,
         claimLineNum: data?.claimLineNum,
         eventInquryKeyVO: [
           {
             keyType: 'Claim ID',
             key: `${data?.claimId}-${data?.claimLineNum}`,
           },
         ],
         functionCode: 'Claim',
         userID: logInUser,
       })
     );
     redirectURLLink(
       `/claimDetails/${data.claimId}`,
       `Claim Details [${data.claimId}]`,
       history,
       dispatch
     );
   };

  const handleFilterChange = (value) => {
    let rowsData = [];
    rowsData = tableData?.filter((item) => item.origNumOfUnits >= 0);
    rowsData = rowsData?.filter((item) => {
      return parseFloat(item.origNumOfUnits) === parseFloat(value);
    });
    rowsData = rowsData?.map((item) => {
      return {
        ...item,
        computedCategoryCd: getReferenceValue(
          claimReferenceData?.CLAIM_CATEGORY_CD || [],
          item.claimCategoryCd
        ),
      };
    });
    const uniqueOriginalUnits = [];
    const indexes = rowsData?.map((item, i) => {
      if (uniqueOriginalUnits?.indexOf(item.origNumOfUnits))
        uniqueOriginalUnits.push(item.origNumOfUnits);
      return i;
    });
    setSelectedRowIndex(indexes);
    setRows(rowsData);
    setSelectedRows(rowsData);
  };
  useEffect(() => {
    handleFilterChange(originalUnit);
    // setRefreshTable(false);
    // const timeout = setTimeout(() => {
    //   setRefreshTable(true);
    // }, 10);
    // return () => clearTimeout(timeout);
  }, [originalUnit]);
  /*
  handleAction is fired on click on ok button of Modal Change Number of Units for Multiple Claims
  and validate the number of Unit Textfoeld value that it should be only numeric value
  and creae data for edited rows and tableRows using the inout value of number of unit by looping over the old tableData variable

  */
  async function handleAction() {
    const payloadData = [];
    const updatedData = [];
    const regex = /^-?[0-9]\d*(\.\d+)?$/;
    if (!regex.test(claimValue)) {
      setClaimValueError(ErrorMessages.ONLY_NUMERIC_ALLOWED);
      return;
    }
    const parsedValue = parseFloat(claimValue);
    if (parsedValue < 0) {
      setClaimValueError(`${ErrorMessages.NUM_OF_UNITS_LESS_THAN_ZERO}.`);
      return;
    }
    setShowModal(false);
    const dataToUpdate = [];
    // build list of selected claim ids
    const selectedClaimIds = Array.isArray(selectedRows) && selectedRows.length > 0
      ? selectedRows.map((el) => el?.claimIdVO?.claimId ?? el?.claimId)
      : [];

    const selectedOrigNumOfUnits = selectedRows && selectedRows[0]
      ? parseFloat(selectedRows[0].origNumOfUnits)
      : null;

    tableData.forEach((el) => {
      const claimId = el?.claimIdVO?.claimId ?? el?.claimId;
      const claimLineNum = el?.claimIdVO?.claimLineNum ?? el?.claimLineNum;
      const elOrigNum = el.origNumOfUnits !== undefined && el.origNumOfUnits !== null
        ? parseFloat(el.origNumOfUnits)
        : null;

      // Only update if the row is selected AND origNumOfUnits matches the selected orig num
      const shouldUpdate =
        selectedClaimIds.includes(claimId) &&
        selectedOrigNumOfUnits !== null &&
        elOrigNum === selectedOrigNumOfUnits;

      const newNumOfUnits = shouldUpdate ? parseFloat(claimValue) : el.numOfUnits;

      const updatedRow = {
        ...el,
        numOfUnits: newNumOfUnits,
      };
      updatedData.push(updatedRow);
      // Push to dataToUpdate and payloadData only if modification happened
      if (updatedRow.numOfUnits !== el.numOfUnits) {
        dataToUpdate.push(updatedRow);

        payloadData.push({
          drugSeqNum: el.drugSeqNum,
          qtr: el.paidQtr,
          claimId: claimId,
          claimLineNum: claimLineNum,
          rebateProgramCd: el.rebateProgramCd,
          labelerCode: el.labelerCode,
          date: formatDateUnix(el.paidDt),
          numOfUnits: updatedRow.numOfUnits,
          billedUnits:
            el.billedUnits !== null
              ? parseFloat(el.billedUnits)
              : parseFloat(el.origNumOfUnits),
          contractSeqNum: '',
          isibwdndc: searchScreenReduxObj?.isibwdndc || false,
          isibwdclaim: searchScreenReduxObj?.isibwdclaim || false,
          wdstatuscd: el.wdStatusCd,
          paidQtr: el.paidQtr,
          dramsQtr: null,
          ildisputeresolution: isChecked ? 1 : 0,
          unitsModFromArInd: el.unitsModFromArInd,
          planTypeCd:
            rebateType === 'Supplemental' ? ErrorMessages.SUPPLEMENTAL : '',
          userInput: 'yes',
          claimLoadDt: el.claimLoadDt,
          corrLinkId: el.corrLinkId,
          userId: userId,
        });
      }
    });

    // Append/replace with dataToUpdate
    let mergedEdited = [];
    if (Array.isArray(editedDataRedux) && editedDataRedux.length > 0) {
      const toUpdateKeySet = new Set(
        dataToUpdate.map(
          (r) => `${r?.claimIdVO?.claimId ?? r?.claimId}__${r?.claimIdVO?.claimLineNum ?? r?.claimLineNum}`
        )
      );

      // keep old edits that are not being updated now
      const keepOld = editedDataRedux.filter((old) => {
        const oldKey = `${old?.claimIdVO?.claimId ?? old?.claimId}__${old?.claimIdVO?.claimLineNum ?? old?.claimLineNum}`;
        return !toUpdateKeySet.has(oldKey);
      });

      mergedEdited = [...keepOld, ...dataToUpdate];
    } else {
      mergedEdited = [...dataToUpdate];
    }

    if (mergedEdited.length > 0) {
      dispatch(setEditedRows(mergedEdited));
    }
    dispatch(setTableData(updatedData));
    dispatch(setSinglePageClaimData(updatedData));
    dispatch(setDisabled(false));
  }

  const handleClose = () => {
    setAnchor(null);
  };
  const id = open ? 'simple-popover' : undefined;

  const selectedClaim = useSelector(
    (state) => state.sharedState.claim.selectedClaim
  );

  const navigateToPage = (pathName, value) => {
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
        from: 'claim',
      });
    } else {
      updateTabs = updateTabs.map((item) => {
        if (item.navTo === pathName) {
          return {
            ...item,
            from: 'claim',
          };
        }
        return item;
      });
    }
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    history.push({
      pathname: pathName,
    });
  };

  const navigateToClaimDetails = (claimId, claimLineNum) => {
    dispatch(setClaimDetailsId({ claimId, claimLineNum, functionCode: 'Claims', }));
    navigateToPage(`/claimDetails/${claimId}`, `Claim Details [${claimId}]`);
  };

  const setSelectedRecordIndex = (index) => {
    dispatch(setSelectedClaimRecordIndex(index));
  };

  useLayoutEffect(() => {
    if (!showComments && props?.data?.corrLinkId)
      dispatch(
        setSelectedClaim(JSON.parse(JSON.stringify([...selectedClaim])))
      );
  }, [showComments]);

  const formatInputValue = (value1) => {
    const val = parseFloat(value1);
    if (typeof val === 'number' && !isNaN(val)) {
      const formattedValue = Math.abs(val)?.toFixed(4);
      return val >= 0 ? formattedValue : `(${formattedValue})`;
    }
    return val;
  };
  return (
    <div
      className="tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center"
      style={{ top: 0 }}
    >
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="delete-tooltip">Comment</Tooltip>}
      >
        <Button
          className="p-0"
          variant="text"
          onClick={() => {
            setCorrLinkId(props?.data?.corrLinkId);
            setCorrId(props?.data?.claimIdVO?.claimId);
            setShowComments(true);
          }}
        >
          <img
            alt="comment"
            role="button"
            src={
              parseInt(props.data?.ccCommentsExist, [0, 1]) === 1
                ? CommentIconVisible
                : CommentIcon
            }
            tabIndex="0"
            onKeyDown={(e) => {
              // Handle Enter and Space key events
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // Prevents the default space scrolling behavior
                setCorrLinkId(props?.data?.corrLinkId);
                setCorrId(props?.data?.claimIdVO?.claimId);
                setShowComments(true);
              }
            }}
          />
        </Button>
      </OverlayTrigger>
      {props?.hasAccess && isEnablebyRole && (
        <>
          <div
            style={{ height: 'max-content' }}
            onClick={(e) => {
              setAnchor(e.currentTarget);
            }}
          >
            <SVGComponent iconName="Export-icon" />
          </div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchor}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div className="d-flex flex-column py-2">
              {selectedClaimMode === 'maintain' && (
                <span
                  className={
                    props?.data?.origNumOfUnits < 0
                      ? 'dropdown-item disabled'
                      : 'dropdown-item'
                  }
                  role="button"
                  onClick={() => {
                    setByRowOrigNumOfUnits(props?.data?.origNumOfUnits);
                    setOriginalUnit(props?.data?.origNumOfUnits);
                    setShowModal(true);
                  }}
                >
                  Change Units on Multiple Claims
                </span>
              )}

              <span
                className="dropdown-item"
                role="button"
                onClick={() => {
                  if (props.data.prevClaimId) {
                    setSelectedRecordIndex(props.rowIndex);
                    navigateToClaimDetails(
                      props.data.prevClaimId,
                      props.data.prevClaimLineNum
                    );
                  } else {
                    setAnchor(null);
                    setError(ErrorMessages.PREVIOUS_CLAIM);
                  }
                }}
              >
                Go to Previous Claim
              </span>
              <span
                className="dropdown-item"
                role="button"
                onClick={() => {
                  if (props.data.replacingClaimId) {
                    setSelectedRecordIndex(props.rowIndex);
                    navigateToClaimDetails(
                      props.data.replacingClaimId,
                      props.data.replacingClaimLineNum
                    );
                  } else {
                    setAnchor(null);
                    setError(ErrorMessages.REPLACE_CLAIM);
                  }
                }}
              >
                Go to Replacement Claim
              </span>
              <span
                className="dropdown-item"
                role="button"
                onClick={() => {
                  if (props.data.reversingClaimId) {
                    setSelectedRecordIndex(props.rowIndex);
                    navigateToClaimDetails(
                      props.data.reversingClaimId,
                      props.data.reversingClaimLineNum
                    );
                  } else {
                    setAnchor(null);
                    setError(ErrorMessages.REVERSING_CLAIM);
                  }
                }}
              >
                Go to Reversing Claim
              </span>
              <span
                className="dropdown-item"
                role="button"
                onClick={() => {
                  handleViewDetailsForClaims(props?.data?.claimIdVO);
                }}
              >
                Go To Claim
              </span>
            </div>
          </Popover>
        </>
      )}
      <ErrorPopup
        modalTitle="Selected Claim"
        errorPopupMessage={error}
        onClose={() => setError(null)}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CLAIM"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={corrId}
        />
      ) : null}
      {showModal && (
        <CommonModal
          open={showModal}
          data-testid="comman_modal1"
          viewAction
          viewHeader
          fullWidth
          className=""
          onOk={() => {
            handleAction('Yes');
          }}
          okTitle="Ok"
          onClose={(value) => {
            // handleAction('No', value);
            setShowModal(false);
          }}
          closeTitle="Cancel"
          modalTitle="Change Number of Units for Multiple Claims"
          childrenComponent={
            <>
              <div className="row">
                <div className="col-12">
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="row mb-2">
                        <div className="col-6">
                          <TextField
                            label="Claim Category: "
                            id="Claim Category"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled
                            value={categoryName}
                          />
                        </div>
                        <div className="col-6">
                          <SelectBoxWithoutBox
                            data-testid="TerminatedLabeler-rebate-program"
                            id="filter-plan-by-radio-btn-action"
                            labelName="Original Units:"
                            required
                            select
                            selectOne
                            optionList={selectList || []}
                            defaultValue={originalUnit}
                            filterAction={(value) => {
                              setOriginalUnit(value);
                              // handleFilterChange(value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row"
                style={{ marginTop: -15, padding: '0px 30px' }}
              >
                <div className="unallocated" style={{ width: '100vw' }}>
                  {refreshTable && (
                    <TableGridWithFeatures
                      gridHeight="40vh"
                      columnDefs={multipleClaimsHead}
                      rowData={rows}
                      rowHeight={20}
                      rowSelection="multiple"
                      selectRowIndex={selectedRowIndex}
                      domLayout="autoHeight" 
                      data-testid="onEditingStopped"
                      enterMovesDown
                      childPopup
                      showResetFilter={false}
                      defaultCol={{
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                      }}
                      hideTotalCount={false}
                      hideColumnsInPdf={['action']}
                      exportFile
                      fileName="Number of Units for Multiple Claims"
                      onSelectionChanged={onSelectionChanged}
                      frameworkComponents={() => {
                        return {
                          categoryComp: (cellInfo) => {
                            const name =
                              cellInfo.tableDataWithComputedValue[
                                cellInfo.rowIndex
                              ].computedCategoryCd;
                            if (name && name.length > 16) {
                              return (
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="labeler-tooltip">
                                      {name}
                                    </Tooltip>
                                  }
                                >
                                  <div>{name}</div>
                                </OverlayTrigger>
                              );
                            }
                            return <div>{name}</div>;
                          },
                        };
                      }}
                      // fullScreenView={fullScreenView}
                      // handleFullScreenViewClick={changeFullScreenView}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="row mb-2">
                        <div className="col-6">
                          <TextField
                            label="Set number of Units for all selected Claims to: "
                            id="setClaimId"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              setClaimValueError('');
                              setClaimValue(e.target.value);
                            }}
                            onBlur={(e) => {
                              const inputValue = e.target.value;
                              const parsedValue = parseFloat(inputValue);
                              if (!isNaN(parsedValue)) {
                                const formattedValue =
                                  formatInputValue(parsedValue);
                                setClaimValueError('');
                                setClaimValue(formattedValue);
                              } else {
                                setClaimValueError('');
                                setClaimValue('');
                              }
                            }}
                            value={claimValue}
                            helperText={claimValueError}
                            className="mandate-fields"
                            error={claimValueError.length}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      )}
    </div>
  );
};

export default CustomSelectedClaimAction;
